import { getinherit, getuserorgs, dentryspacemsg, validurldddress, getuserroles } from '@/port/schoolInstrument/appConfig'
import { validateapprovaltimeswitch, outvalidateapprovaltimeswitch } from '@/port/clientSide/oaExamineAudit'
import { cloneDeep } from 'lodash'
import { ElMessage } from 'element-plus'
import Axios from 'axios'
import qs from 'qs'
import { timeFormatDate, getOrgShowName } from "@/api/global"
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { MY_CONSTANTS } from '@/util/constants'

export const applyIsConditionAppen = (info, customData) => {
  return info.filter(item => {
    if (item.apply && item.apply.length) {
      item.apply = item.apply.filter(iter => {
        let isView = true
        if (isView && iter.condition) {
          isView = isConditionAppen(iter.condition, {}, true, customData)
        }
        return isView
      })
    }
    let isView = true
    if (isView && item.condition) {
      isView = isConditionAppen(item.condition, {}, true, customData)
    }
    return isView
  })
}

export const stringToArrayBufferUpLoad = (opt, that) => {
  const { name = 'config.txt', uploadStr, type = 'text/plain;charset=utf-8' } = opt
  if (!uploadStr) return
  const blob = new Blob([new TextEncoder().encode(uploadStr)], { type })
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
    const url = that.$apiurl + '/userfile/upload?accesstoken=' + token
    const file = new File([blob], name, {
      type: 'text/plain'
    })
    const formData = new FormData()
    formData.append('file', file)
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    Axios.post(url, formData, config)
      .then(res => {
        const configUrl = `/userfiles/${res.data}`
        resolve(configUrl)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const colorRgb = (str, opacity) => {
  // 十六进制取透明度
  var sColor = str.toLowerCase()
  if (sColor) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    var sColorChange = []
    // eslint-disable-next-line no-redeclare
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')'
  } else {
    return sColor
  }
}
// 数组去重
export const deduplicate = (arr, t = "") => {
  const obj = {}, newArr = []
  // 有指定字段
  if (t) {
    for (let i = 0; i < arr.length; i++) {
      if (!obj[arr[i][t]]) {
        obj[arr[i][t]] = 1
        newArr.push(arr[i])
      }
    }
  }
  // 无指定字段
  else {
    for (let i = 0; i < arr.length; i++) {
      if (!obj[arr[i]]) {
        obj[arr[i]] = 1
        newArr.push(arr[i])
      }
    }
  }
  return newArr
}

export const getPermission = async (content) => {
  const res = await getinherit({
    content
  })
  if (res.code === 0) {
    return res.data
  }
  return false
}

const setIsPermissionAppen = async (item, roleList, organization = []) => {
  const user = localStorage.getItem('user')
  if (!user) {
    item.isPermissionAppen = true
  } else if (item.permissinSet === 'open') {
    item.isPermissionAppen = true
  } else if (item.permissinSet === 'inherit') {
    // 权限继承
    item.isPermissionAppen = await getPermission(item.permissionList)
  } else {
    // 选择角色
    if (item.roleArr && item.roleArr.length !== 0) {
      // 查找当前角色是否在这个菜单里面配置了 如果配置了则返回
      const i = item.roleArr.findIndex(i => {
        // 如果说在角色列表中找到了该角色 就直接返回true
        if (i.roleId) {
          return roleList.some(v => v.roleId === i.roleId)
        } else if (i.organizationId) {
          return organization.some(v => v.OrganizationId === i.organizationId)
        }
      })
      if (i !== -1) {
        item.isPermissionAppen = true
      }
    } else if (item.roleArr && item.roleArr.length === 0) {
      item.isPermissionAppen = false
    } else if (item.roleArr === undefined) {
      item.isPermissionAppen = true
    }
  }
  return item
}

// 处理角色权限
export const dealRolePermission = async (opt) => {
  const { val = [], roleList = [], children = 'apply' } = opt
  const user = localStorage.getItem('user')
  let organization = {}
  if (user) {
    const userorg = await getuserorgs()
    organization = userorg.data
  }
  const list = cloneDeep(val)
  for (let menu of list) {
    if (menu[children] && menu[children].length !== 0) {
      // 有子栏目
      for (let item of menu[children]) {
        item = await setIsPermissionAppen(item, roleList, organization)
      }
      if (children === 'lists') {
        menu = await setIsPermissionAppen(menu, roleList, organization)
      }
      if (children === 'apply') {
        menu = await setIsPermissionAppen(menu, roleList, organization)
      }
    } else {
      // 没有子栏目
      menu = await setIsPermissionAppen(menu, roleList, organization)
    }
  }
  return list
}

export const isValidateapprovaltimeswitch = async (opt, upaceId) => {
  const { approvalId, type } = opt
  let fn = validateapprovaltimeswitch
  const user = localStorage.getItem('user')
  if (!user) {
    fn = outvalidateapprovaltimeswitch
  }
  let obj = { type, approvalId }
  if (upaceId) {
    obj.upaceid = upaceId
  }
  const res = await fn(obj)
  if (res.code === 0) {
    if (res.data.switch) {
      ElMessage.warning(res.data.tips)
    }
    return res.data.switch
  } else {
    ElMessage.error(res.msg)
    return false
  }
}

export const getDentryspacemsg = async (skey) => {
  const res = await dentryspacemsg({ skey })
  if (res.code === 0) {
    if (res.data.spaceid) {
      return res.data.spaceid
    } else {
      return false
    }
  } else {
    return false
  }
}

export const getToolBgInfo = (toolfllStyle) => {
  if (toolfllStyle) {
    const fillstyle = {}
    if (toolfllStyle.bgstyle === 'picture') {
      // 背景填充图片
      if (toolfllStyle.picture.layout === 'default') {
        // 原大小填充
        fillstyle.background = `url('${MY_CONSTANTS.$imgurl + toolfllStyle.picture.url}') no-repeat`
      } else if (toolfllStyle.picture.layout === 'adaption') {
        // 自适应填充
        fillstyle.background = `url('${MY_CONSTANTS.$imgurl + toolfllStyle.picture.url}') no-repeat`
        fillstyle.backgroundSize = 'cover'
      }
    } else if (toolfllStyle.bgstyle === 'color') {
      // 背景填充颜色
      fillstyle.backgroundColor = toolfllStyle.color
    }
    return fillstyle
  } else {
    return ''
  }
}

export const getRadioBgInfo = (bgInfo = {}, opt = {}) => {
  const radio = bgInfo.radio
  const { defaultColor = '#fff', bgImgLayout = 'adaption' } = opt
  const img = bgInfo.imageUrl
  if (radio === 'color') {
    return {
      background: bgInfo.color
    }
  } else if (radio === 'image') {
    const obj = { backgroundImage: `url('${MY_CONSTANTS.$imgurl + img}')` }
    if (bgImgLayout !== 'adaption') {
      obj.backgroundSize = 'cover'
      obj.backgroundRepeat = 'no-repeat'
      obj.backgroundPosition = 'center center'
    }
    return obj
  } else {
    return {
      background: defaultColor
    }
  }
}


export const dealQueryStr = (str) => {
  if (!str) return
  const query = typeof str === 'string' ? JSON.parse(str) : str
  return query
}

export const dealScreenOpt = (arr = []) => {
  if (arr.length === 0) return true
  const numUserDate = {
    number: true,
    date: true,
    timeof: true,
    dates: true,
    'relation-user': true,
    appuser: true,
  }
  const defaultObj = {
    orders: true,
    status: true,
    text: true,
    textarea: true,
    radio: true,
    checkbox: true,
    richTextWid: true,
    'new-rel-radio': true,
    'relation-check': true,
    label: true
  }
  let flag = true
  for (const info of arr) {
    if (numUserDate[info.screenType]) {
      flag = false
      break
    } else if (defaultObj[info.screenType] && (info.bindField || info.value)) {
      flag = false
      break
    }
  }
  return flag
}

export function parseWidth(width) {
  if (width !== undefined) {
    width = parseInt(width, 10)
    if (isNaN(width)) {
      width = null
    }
  }
  return width
}


export const getObtainTheNumericalRange = (num, range) => {
  if (!range) return false
  if (num >= range[0] && num <= range[1]) {
    return true
  } else {
    return false
  }
}

export const generateHTMLTableWithWidth = (sheetData = [], styleOption = {}) => {
  if (!Array.isArray(sheetData)) return ''
  const { tableWidth = 0, tableStyleField = {}, titleStyleConfig = {}, filedWidthList = [], colsTotalWidth = [], checkSyllable = [], isGetWidth = true } = styleOption
  const isPercent = tableStyleField.tableWidth === 'scroll'
  const elTableW = []
  let html = "<table class='excel-table' style='border-collapse: collapse;width: 100%;height: 100%;'>"
  if (isPercent) {
    html = '<table class=\'excel-table\' style=\'border-collapse: collapse;width: max-content;height: 100%;\'>'
  } else {
    html = `<table class='excel-table' style='border-collapse: collapse;width: ${tableWidth}px;height: 100%;table-layout:fixed;'>`
  }

  // 遍历每个工作表
  sheetData.forEach(sheet => {
    const data = sheet.data // 获取工作表中的数据（二维数组）
    const merges = sheet.config && sheet.config.merge ? sheet.config.merge : {} // 获取合并单元格信息
    const columnWidths = sheet.config && sheet.config.columnlen ? sheet.config.columnlen : {} // 获取列宽信息
    const rowHeights = sheet.config && sheet.config.rowlen ? sheet.config.rowlen : {} // 获取行高信息
    const mergedCells = {} // 存储已经处理过的合并单元格
    const rowCount = data.length // 总行数
    const COMMONW = isPercent ? 170 : 73
    // 生成列宽样式
    html += '<colgroup>'
    let totalW = 0
    let stepW = 0
    let afterStepW = 0
    let widthLi = []
    for (let j = 0; j < data[0].length; j++) {
      totalW += (columnWidths[j] || COMMONW)
    }
    let per = 100
    let abv = 0
    for (let j = 0; j < data[0].length; j++) {
      const value = data[0][j] || {}
      const curChange = filedWidthList.find(item => item.id === value.cell_id)
      const width = columnWidths[j] || COMMONW // 如果没有宽度信息，使用默认宽度100px
      if (isPercent) {
        elTableW.push(width)
        // 没有表格宽度 默认就是px  其他时候用百分比  或者是滚动的时候用
        html += `<col name="${value.cell_id}" width=${width}>`
        if (j == 0) {
          widthLi[j] = 40
        } else {
          widthLi[j] = widthLi[j - 1] + (columnWidths[j - 1] || COMMONW)
        }
      } else {
        let percentage = Math.floor((width / totalW).toFixed(4) * 100)
        if (curChange) {
          percentage = curChange.percentage * 100
        }

        per -= percentage

        if (j === data[0].length - 1) {
          if (per > 0) {
            percentage += per
          } else {
            percentage -= per
          }
        }
        abv += percentage
        let w = Math.floor((percentage / 100) * tableWidth)
        stepW += w
        for (const col of colsTotalWidth) {
          const range = [col - 20, col + 20]
          const flag = getObtainTheNumericalRange(stepW, range)
          if (flag) {
            w = col - afterStepW
            break
          }
        }
        afterStepW += w
        if (j == 0) {
          widthLi[j] = 40
        } else {
          widthLi[j] = widthLi[j - 1] + w
        }
        html += `<col name="${value.cell_id}" width=${w}>`
      }
    }
    console.log(abv, 'abvabvabv');

    html += '</colgroup>'
    // 遍历每一行
    for (let i = 0; i < data.length; i++) {
      const rowHeight = rowHeights[i] || 34
      html += `<tr style="height: ${rowHeight}px;">`
      const row = data[i]
      // 遍历每一列
      for (let j = 0; j < row.length; j++) {
        // 检查是否已经处理过该单元格
        if (mergedCells[`${i}_${j}`]) {
          continue // 如果该单元格是合并范围内的子单元格，跳过
        }
        // 获取单元格值
        let cellValue = row[j] && row[j].v !== undefined ? row[j].v : ''
        if (cellValue === null) {
          // 为null时 给空字符串
          cellValue = ''
        }
        // 获取单元格样式信息
        const cellStyle = row[j] || {}
        let styleString = 'padding: 0 10px;'
        let classString = ''
        // 处理背景颜色
        if (cellStyle.bg !== undefined) {
          styleString += `background-color: ${cellStyle.bg};`
        }

        // 处理字体大小
        if (cellStyle.fs !== undefined) {
          styleString += `font-size: ${cellStyle.fs}px;`
        } else {
          styleString += `font-size: ${titleStyleConfig.fontSize};`
        }

        // 处理字体颜色
        if (cellStyle.fc !== undefined) {
          styleString += `color: ${cellStyle.fc};`
        } else {
          styleString += `color: ${titleStyleConfig.color};`
        }

        // 处理字体格式
        if (cellStyle.ff !== undefined) {
          styleString += `font-family: ${cellStyle.ff};`
        } else {
          styleString += `font-family: ${titleStyleConfig.fontFamily};`
        }

        // 处理水平对齐方式
        if (cellStyle.ht !== undefined) {
          const ht = Number(cellStyle.ht)
          const align = ht === 1 ? 'left' : (ht === 0 ? 'center' : 'right')
          styleString += `text-align: ${align};`
        } else {
          styleString += `text-align: ${titleStyleConfig.textAlign};`
        }

        // 处理垂直对齐方式
        if (cellStyle.vt !== undefined) {
          const valign = +cellStyle.vt === 0 ? 'top' : (+cellStyle.vt === 1 ? 'middle' : 'bottom')
          styleString += `vertical-align: ${valign};`
        }

        if (checkSyllable[j] && checkSyllable[j].fixed) {
          classString += 'sticky-fixed '
          styleString += `position: sticky;left: ${widthLi[j]}px;background: #f8f9fb;`
        }

        // 处理字体加粗
        if (cellStyle.bl !== undefined) {
          styleString += 'font-weight: bold;'
        } else {
          styleString += `font-weight: ${titleStyleConfig.fontWeight};`
        }
        // 加 边框
        styleString += 'border: 1px solid #EBEEF5;'
        if (i === rowCount - 1) {
          styleString += 'border-bottom: none;' // 移除底部边框
        }
        // 检查该单元格是否在合并范围内
        if (merges[`${i}_${j}`]) {
          const mergeInfo = merges[`${i}_${j}`]
          const rowspan = mergeInfo.rs || 1 // 获取 rowspan（行合并）
          const colspan = mergeInfo.cs || 1 // 获取 colspan（列合并）
          // 标记所有被合并的单元格为已处理
          for (let r = i; r < i + rowspan; r++) {
            for (let c = j; c < j + colspan; c++) {
              mergedCells[`${r}_${c}`] = true
            }
          }
          // 处理合并单元格的边框：保留主单元格的边框，移除内部单元格的边框
          if (rowspan === rowCount) {
            styleString += 'border-bottom: none;'
          }
          // 生成合并单元格的 HTML，并应用样式
          html += `<td data-id="${row[j].cell_id}" class="custom-excel-td td-${row[j].cell_id} ${classString}" rowspan="${rowspan}" colspan="${colspan}" style="${styleString}">${cellValue}</td>`
        } else {
          // 生成普通单元格的 HTML，并应用样式
          html += `<td data-id="${row[j].cell_id}" class="custom-excel-td td-${row[j].cell_id} ${classString}" style="${styleString}">${cellValue}</td>`
        }
      }
      html += '</tr>'
    }
  })
  html += '</table>'
  if (isGetWidth) {
    return {
      html,
      elTableW
    }
  }
  return html
}

export const generateTableList = (sheetData = [], tableFiledList = []) => {
  if (!Array.isArray(sheetData)) return tableFiledList
  const list = cloneDeep(tableFiledList)
  sheetData.forEach(sheet => {
    const data = sheet.data // 获取工作表中的数据（二维数组）
    const columnWidths = sheet.config && sheet.config.columnlen ? sheet.config.columnlen : {} // 获取列宽信息
    for (let j = 0; j < data[0].length; j++) {
      const width = columnWidths[j] || 170 // 如果没有宽度信息，使用默认宽度100px
      console.log(list[j], 'list[j]')
      if (list[j]) {
        list[j].width = width
      }
    }
  })
  return list
}

let scrollBarWidth

export const getScrollbarWidth = () => {
  if (scrollBarWidth !== undefined) return scrollBarWidth;
  const outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
}

export const getPageSize = (opt, def = 25) => {
  const { pageNum, customPageNum } = opt
  if (!pageNum) return def
  if (['custom', 'lineAdaption', 'textAdaption'].includes(pageNum)) {
    return Number(customPageNum)
  } else {
    return Number(pageNum)
  }
}

export const isScrollAtBottom = (el) => {
  const height = el.target
  const clientHeight = height.clientHeight
  const scrollTop = height.scrollTop
  const scrollHeight = height.scrollHeight
  return clientHeight + scrollTop === scrollHeight
}

export const isScrollAtRight = (el, distance = 300) => {
  const height = el.target
  const clientWidth = height.clientWidth
  const scrollLeft = height.scrollLeft
  const scrollWidth = height.scrollWidth

  return scrollWidth - (clientWidth + scrollLeft) <= distance
}

// 导出一个函数，用于判断元素是否接近底部
export const isScrollNearBottom = (el) => {
  // 不知道为什么  就是判断不到底部
  // 获取元素的高度
  const height = el.target
  // 获取元素的可视高度
  const clientHeight = height.clientHeight
  // 获取元素的滚动高度
  const scrollTop = height.scrollTop
  // 获取元素的总高度
  const scrollHeight = height.scrollHeight
  // 判断元素是否接近底部，如果元素的总高度减去元素的可视高度和滚动高度小于2，则返回true，表示元素接近底部
  return scrollHeight - (clientHeight + scrollTop) < 2
}

export const processPaging = (opt = {}) => {
  const { pagesize, list } = opt
  const li = []
  const len = +list.length
  let idx = 0
  let resIdx = idx + pagesize
  if (resIdx > len) {
    li.push(list)
    return li
  }
  while (resIdx <= len) {
    if (resIdx > len) {
      resIdx = len
    }
    const cli = list.slice(idx, resIdx)
    idx += pagesize
    resIdx = idx + pagesize
    li.push(cli)
  }
  const l = list.splice(idx, resIdx)
  li.push(l)
  console.log(li,'sadsadsadsa')
  return li
}

export const isValidUrl = (url) => {
  try {
    new URL(url)
    return true
  } catch (error) {
    return false
  }
}

export const getXhrStatus = async (internalInfo) => {
  // 郑工说 用时间去判断  如果说小于三秒  则直接去判断是跨域
  const nowTime = new Date().getTime()
  try {
    const response = await fetch(internalInfo.internalIp, { method: 'HEAD' })
    if (response.ok) {
      return true
    } else {
      return false
    }
  } catch (error) {
    const endTime = new Date().getTime()
    const time = endTime - nowTime
    if (time < 3000) {
      return true
    } else {
      return false
    }
  }
}
export const isItAnInternalNetwork = async (internalInfo) => {
  if (!internalInfo) return false
  if (!internalInfo.isInternal) return false
  if (internalInfo.isInternal) {
    if (!isValidUrl(internalInfo.internalIp)) {
      ElMessage.error('请输入正确的内部链接')
      return true
    }
    const res = await getXhrStatus(internalInfo)
    if (res) {
      // 前端判断内网
      const data = await validurldddress({ urlAddress: internalInfo.internalIp })
      if (data.data) {
        return true
      } else {
        return 'internalNetwork'
      }
    } else {
      // 前端判断外网
      const data = await validurldddress({ urlAddress: internalInfo.internalIp })
      if (data.data) {
        return 'shutdown'
      } else {
        return 'internalNetwork'
      }
    }
  }
}

export const getSearch = (url) => {
  if (!url) return
  const search = url.split('?')
  if (search.length > 0) {
    let s = search.slice(1, search.length)
    s = s.join('?')
    s = qs.parse(s)
    if (s.search) {
      const se = JSON.parse(s.search)
      const obs = {}
      // const key = []
      const obj = {
        '归档状态_status': 'archive_radio',
        '申请人_relation-user': 'appuser_appuser'
      }
      const statusObj = {
        '待审批': 0,
        '已通过': 1,
        '未通过': 2,
        '已撤回': 3
      }
      for (const i in se) {
        const val = Array.isArray(se[i]) ? se[i] : [se[i]]
        // 数字值处理下
        if (i === 'status_status') {
          for (let s = 0; s < val.length; s++) {
            val[s] = statusObj[val[s]] || val[s]
          }
        } else if (i === 'date_timeof') {
          for (let s = 0; s < val.length; s++) {
            val[s] = timeFormatDate(new Date(val[s]).getTime())
          }
          if (val.length === 1) {
            val.push(val[0])
          }
        }
        if (obj[i]) {
          obs[obj[i]] = val
        } else {
          obs[i] = val
        }
      }
      return obs
    }
  }
}

export const isObject = (val) => {
  return typeof val === 'object' && val !== null
}

export const isJSON = (val) => {
  return typeof val === 'string' ? JSON.parse(val) : val
}

export const trimHtml = (str) => {
  str = str.replace(/(\n)/g, "");
  str = str.replace(/(\t)/g, "");
  str = str.replace(/(\r)/g, "");
  str = str.replace(/<\/?[^>]*>/g, "");
  str = str.replace(/\s*/g, "");
  str = str.replace(/<[^>]*>/g, "");
  return str;
}

export const generateTreeDataWithSorting = ({ data, isFilter, bespeakdeptids = [], isAppenSubordinate = true, isShowLastUser = false }) => {
  const _data = JSON.parse(JSON.stringify(data))
  const map = new Map();
  const tree = [];
  let isAppenGraduation = false
  // 首先将所有节点存入 Map，以便快速查找
  let li = _data
  for (const item of li) {
    if (getOrgShowName(item).includes('(已毕业)')) {
      isAppenGraduation = true
      break
    }
  }
  if (isFilter) {
    li = _data.filter(item => !(getOrgShowName(item).includes('(已毕业)')))
  }
  let res = []
  if (bespeakdeptids.length !== 0) {
    for (const organizationId of bespeakdeptids) {
      const idx = li.findIndex(item => item.organizationId === organizationId)
      if (idx !== -1) {
        if (isAppenSubordinate) {
          li[idx].pid = 0
          res.push(li[idx])
          li.splice(idx, 1)
        } else {
          res.push(li[idx])
        }
      }
    }
  }
  if (isAppenSubordinate) {
    res = res.concat(li)
  }
  const defalutRes = {
    children: [],
    leaf: true
  }
  if (isShowLastUser) {
    defalutRes.leaf = false
  }
  res.forEach(item => {
    map.set(item.organizationId, { ...item, ...cloneDeep(defalutRes) });
  })
  // 遍历所有节点，构建树
  res.forEach(item => {
    if (item.pid === 0) {
      // 没有父节点，说明是顶级节点
      tree.push(map.get(item.organizationId));
    } else {
      // 找到对应的父节点，加入其 children
      const parent = map.get(item.pid);
      if (parent) {
        parent.children.push(map.get(item.organizationId));
        parent.leaf = false;
      }
    }
  })
  // 排序函数，优先按 order 排序，没有 order 则按 createTime 排序
  // const sortNodes = nodes => {
  //   nodes.sort((a, b) => {
  //     if (a.orders !== undefined && b.orders !== undefined) {
  //       return a.orders - b.orders;
  //     } else if (a.orders !== undefined) {
  //       return -1; // a 有 order，排在前面
  //     } else if (b.orders !== undefined) {
  //       return 1; // b 有 order，排在前面
  //     } else {
  //       // 如果都没有 order，按 createTime 排序
  //       return new Date(a.organizationId) - new Date(b.organizationId);
  //     }
  //   });
  //   // 递归对子节点排序
  //   nodes.forEach(node => {
  //     if (node.children.length > 0) {
  //       sortNodes(node.children);
  //     }
  //   });
  // }

  // 排序顶层节点
  // sortNodes(tree);

  return {
    tree,
    isAppenGraduation
  };
}

export const getBottomLayerId = (opt = {}) => {
  const { data = {}, type = 'id', isChildren = true, chooseTag = 0 } = opt
  const ids = []
  if (!data.children) {
    data.children = []
  }
  if (!isChildren) {
    if (chooseTag === 0 || chooseTag === undefined || chooseTag === data.type) {
      if (type === 'id') {
        ids.push(data.organizationId || data.organizationid)
      } else if (type === 'org') {
        ids.push({
          organizationId: data.organizationId || data.organizationid,
          name: data.name
        })
      } else if (type === 'name') {
        ids.push(data.name)
      }
    }
    return ids
  }
  if (data.children.length === 0) {
    if (chooseTag === 0 || chooseTag === undefined || chooseTag === data.type) {
      if (type === 'id') {
        ids.push(data.organizationId || data.organizationid)
      } else if (type === 'org') {
        ids.push({
          organizationId: data.organizationId || data.organizationid,
          name: data.name
        })
      } else if (type === 'name') {
        ids.push(data.name)
      }
    }
  } else {
    for (const ele of data.children) {
      if (ele.children) {
        const id = getBottomLayerId({ data: ele, type, isChildren })
        if (ele.leaf) {
          if (chooseTag === 0 || chooseTag === undefined || chooseTag === data.type) {
            if (type === 'id') {
              ids.push(ele.organizationId || ele.organizationid)
            } else if (type === 'org') {
              ids.push({
                organizationId: ele.organizationId || ele.organizationid,
                name: ele.name
              })
            } else if (type === 'name') {
              ids.push(ele.name)
            }
          }
        }
        ids.push(...id)
      }
    }
  }
  return ids
}


export const treeExpandOrFold = (treeRef, isExpandAll) => {
  if (!treeRef) return
  const set = new Set()
  const fn = () => {
    const allNodes = treeRef.store._getAllNodes()
    allNodes.forEach(node => {
      if (node.data.children.length !== 0 && !set.has(node.id)) {
        node.expanded = isExpandAll
        set.add(node.id)
        if (isExpandAll) {
          node.expand()
        } else {
          node.collapse()
        }
        fn()
      }
    })
  }
  fn()
}


/**
 * 在树结构中查找节点（增强版）
 * @param {Object} root 树的根节点
 * @param {*} [targetId] 要查找的目标ID（可选，如果提供match函数可不传）
 * @param {Object} [options] 配置选项
 * @param {string} [options.idKey='id'] ID字段名
 * @param {string} [options.childrenKey='children'] 子节点字段名
 * @param {string} [options.mode='BFS'] 遍历模式：'BFS'或'DFS'
 * @param {Function} [options.match] 自定义匹配函数，优先级高于targetId
 * @param {boolean} [options.returnParent=false] 是否返回父节点
 * @param {boolean} [options.returnPath=false] 是否返回完整路径
 * @param {number} [options.maxDepth=Infinity] 最大搜索深度
 * @param {Function} [options.onNodeVisited] 节点访问回调函数
 * @returns {Object|null} 根据配置返回不同结果
 */
export function findTreeNodeEnhanced(root, targetId, options = {}) {
  // 参数判断和处理
  if (arguments.length === 2 && typeof targetId === 'object') {
    options = targetId;
    targetId = undefined;
  }

  if (!root) return null;

  // 合并默认选项
  const {
    idKey = 'id',
    childrenKey = 'children',
    mode = 'BFS',
    match = null,
    returnParent = false,
    returnPath = false,
    maxDepth = Infinity,
    onNodeVisited = null
  } = options;

  // 验证参数
  if (!match && targetId === undefined) {
    throw new Error('必须提供targetId或match函数');
  }

  // 初始化遍历结构
  const queueOrStack = [{
    node: root,
    parent: null,
    path: [root],
    depth: 0
  }];
  while (queueOrStack.length > 0) {
    const current = mode === 'BFS' ? queueOrStack.shift() : queueOrStack.pop();
    const { node, parent, path, depth } = current;

    // 检查最大深度
    if (depth > maxDepth) continue;

    // 调用访问回调
    if (onNodeVisited) {
      const shouldContinue = onNodeVisited(node, { parent, path, depth });
      if (shouldContinue === false) break;
    }

    // 检查是否匹配
    const isMatch = match ? match(node) : node[idKey] === targetId;

    if (isMatch) {
      const result = { node };
      if (returnParent) result.parent = parent;
      if (returnPath) result.path = path;
      if (returnParent || returnPath) return result;
      return node;
    }

    // 处理子节点
    const children = node[childrenKey];
    if (Array.isArray(children) && depth < maxDepth) {
      const childrenToAdd = mode === 'DFS' ? [...children].reverse() : children;
      for (const child of childrenToAdd) {
        queueOrStack.push({
          node: child,
          parent: node,
          path: [...path, child],
          depth: depth + 1
        });
      }
    }
  }
  return null;
}


/**
 * 将树结构中的所有子节点提取到一个扁平数组中（可自定义 children 键名）
 * @param {Object} tree - 树结构的根节点
 * @param {string} [childrenKey='children'] - 自定义的子节点键名
 * @returns {Array} - 包含所有子节点的数组
 */
export function flattenTreeWithWhile(tree, childrenKey = 'children') {
  const result = [];
  const stack = [tree];

  while (stack.length > 0) {
    const currentNode = stack.pop();

    // 使用自定义的 childrenKey 访问子节点
    if (currentNode[childrenKey] && currentNode[childrenKey].length > 0) {
      // 保持原始顺序
      stack.push(...currentNode[childrenKey].slice().reverse());

      // 将子节点添加到结果数组
      result.push(...currentNode[childrenKey]);
    }
  }

  return result;
}


/**
 * 过滤掉树结构中 ID 在指定数组中的节点
 * @param {Array} tree - 原始树结构数据（通常是一个数组）
 * @param {Array} idsToRemove - 需要被过滤掉的 ID 数组
 * @returns {Array} - 返回过滤后的新树
 */
export function filterTreeByIds(tree, idsToRemove, options = {}) {
  // 将数组转为 Set，提高查询效率（时间复杂度从 O(n) 降为 O(1)）
  if (idsToRemove.length === 0) return tree
  const idSet = new Set(idsToRemove)
  const { children = 'children', id = 'id' } = options
  const idx = tree.findIndex(node => idSet.has(node[id]))
  let newTree = tree
  if (idx !== -1) {
    newTree = tree.filter(node => idSet.has(node[id])) // 如果当前节点 ID 在黑名单中，直接过滤掉
  }
  return newTree.map(node => {
    // 如果该节点有子节点，递归处理子节点
    if (node[children] && node[children].length > 0) {
      return {
        ...node, // 保持原节点属性
        children: filterTreeByIds(node[children], idsToRemove, options) // 覆盖为过滤后的子节点
      };
    }
    return node;
  })
}

export function manualParseQuery(queryStr) {
  const result = {};
  
  // 1. 先处理 HTML 实体
  queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  
  // 2. 如果字符串为空，返回空对象
  if (!queryStr) return result;
  
  // 3. 手动解析，遇到 & 但不一定是分隔符
  // 策略：按 & 分割后，再检查每个部分是否包含 =
  // 如果某个部分不包含 =，说明它是上一个参数值的一部分
  
  const parts = queryStr.split('&');
  const pairs = [];
  
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    
    // 检查这个部分是否包含 =
    if (part.includes('=')) {
      // 这是完整的键值对
      pairs.push(part);
    } else {
      // 这个部分不包含 =，说明它是上一个参数值的一部分
      // 把它拼接到上一个参数值后面
      if (pairs.length > 0) {
        const lastIndex = pairs.length - 1;
        pairs[lastIndex] += '&' + part;
      } else {
        // 极端情况：第一个部分就不包含 =，直接作为键
        pairs.push(part + '=');
      }
    }
  }
  
  // 4. 解析每个键值对
  for (const pair of pairs) {
    const equalIndex = pair.indexOf('=');
    if (equalIndex === -1) {
      // 没有 =，整个作为 key，value 为空字符串
      const key = decodeValue(pair);
      result[key] = '';
    } else {
      const key = pair.substring(0, equalIndex);
      let value = pair.substring(equalIndex + 1);
      
      // 解码
      const decodedKey = decodeValue(key);
      const decodedValue = decodeValue(value);
      result[decodedKey] = decodedValue;
    }
  }
  
  return result;
}
export function aiParseQuery(queryStr) {
  const result = {};

  if (!queryStr) return result;

  // 先把所有 HTML 实体还原，必须在 split('&') 之前处理
  // 否则 &quot; 会被拆成 quot; 残片，其后续 HTML 属性中的 = 会被误判为新参数的分隔符
  // 注意：&amp; 放最后替换，避免 &amp;quot; 被二次展开
  // 过滤原始 <img> 等媒体标签（path 未经 URL 编码时，标签以真实 HTML 形式出现）
  // 必须在 split('&') 之前处理，否则标签属性中的 & 会被误拆为新参数
  queryStr = queryStr.replace(/<(img|video|audio|iframe|embed|source|track)\b[\s\S]*?(?:\/?>|(?=<[a-zA-Z])|$)/gi, '');

  // 过滤 HTML 实体编码形式的 img 等媒体标签（path 经过 URL 编码时出现）
  // & 尚未被还原，URL 中的参数不会被后续 split('&') 误拆
  queryStr = queryStr.replace(/&lt;(img|video|audio|iframe|embed|source|track)\b[\s\S]*?(?:&gt;|(?=&lt;)|$)/gi, '');

  queryStr = queryStr
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&');

  // 合法的 URL 参数名：字母/下划线开头，后跟字母、数字、下划线、中括号
  // 用此规则区分"真正的新 key=value"和"value 内容中碰巧含 = 的片段"
  const KEY_RE = /^[A-Za-z_][A-Za-z0-9_[\]]*=/;

  const parts = queryStr.split('&');
  const pairs = [];

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (KEY_RE.test(part)) {
      pairs.push(part);
    } else {
      if (pairs.length > 0) {
        pairs[pairs.length - 1] += '&' + part;
      } else {
        pairs.push(part + '=');
      }
    }
  }

  for (const pair of pairs) {
    const equalIndex = pair.indexOf('=');
    if (equalIndex === -1) {
      result[decodeValue(pair)] = '';
    } else {
      const key = decodeValue(pair.substring(0, equalIndex));
      const value = decodeValue(pair.substring(equalIndex + 1));
      result[key] = value;
    }
  }

  return result;
}

function stripHtml(str) {
  return str
    // 先删除 <img> / <video> / <audio> / <iframe> 等媒体标签（属性中可能含裸引号，需单独处理）
    .replace(/<(img|video|audio|iframe|embed|source|track)\b[\s\S]*?(?:\/?>|>)/gi, '')
    // 删除 <script> / <style> 及其内容
    .replace(/<(script|style)\b[\s\S]*?<\/\1>/gi, '')
    // 删除其余所有 HTML 标签
    .replace(/<[^>]*>/g, '')
    // 还原常见 HTML 实体
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&#\d+;/g, '')
    // 合并多余空白
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/(\r?\n|\r){2,}/g, '\n')
    .trim();
}

// 解码辅助函数
function decodeValue(str) {
  if (!str) return '';
  
  // 处理 + 号（URL 中 + 代表空格）
  let processed = str.replace(/\+/g, ' ');
  
  try {
    return stripHtml(decodeURIComponent(processed));
  } catch (e) {
    return stripHtml(str);
  }
}

export const getcuruserorgs = async ()=> {
  const res = await getuserorgs()
  if (res.code === 0) {
    return res.data.map(item => {
      return {
        name: item.name,
        organizationId: item.OrganizationId
      }
    })
  }
}
export const getcuruserroles = async ()=> {
  const res = await getuserroles()
  if (res.code === 0) {
    return res.data.list
  }
}
